'use client';

import { c as _c } from "react/compiler-runtime";
import { Drawer, DrawerContent, DrawerTitle, DrawerTrigger } from '@achra/ui/drawer';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@achra/ui/dropdown-menu';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { startTransition, useEffect, useRef, useState } from 'react';
import { useMountedState } from 'react-use';
import { useMediaQuery } from '@/modules/shared/hooks/use-media-query';
import type { BreadcrumbItemNavigation } from '@/modules/shared/types/breadcrumb';
import { MobileItem } from './mobile-item';
import { TriggerIcon } from './trigger-icon';
interface DotsSegmentProps {
  items: BreadcrumbItemNavigation[];
  defaultOpen?: boolean;
}
function DotsSegment(t0) {
  const $ = _c(29);
  const {
    items,
    defaultOpen: t1
  } = t0;
  const defaultOpen = t1 === undefined ? false : t1;
  const [open, setOpen] = useState(defaultOpen);
  const pathname = usePathname();
  const prevPathnameRef = useRef(pathname);
  const isMounted = useMountedState();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      to: "md"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const isMobile = useMediaQuery(t2);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      to: "lg"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const isMobileOrTablet = useMediaQuery(t3);
  let t4;
  if ($[2] !== isMobileOrTablet || $[3] !== items) {
    t4 = isMobileOrTablet ? items.slice(0, -1) : items;
    $[2] = isMobileOrTablet;
    $[3] = items;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const itemsToRender = t4;
  const currentItemLabel = items[items.length - 1].label;
  let t5;
  let t6;
  if ($[5] !== pathname) {
    t5 = () => {
      if (prevPathnameRef.current !== pathname) {
        prevPathnameRef.current = pathname;
        startTransition(() => {
          setOpen(false);
        });
      }
    };
    t6 = [pathname];
    $[5] = pathname;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  useEffect(t5, t6);
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setOpen(false);
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const handleOpenChange = t7;
  if (isMobile && isMounted()) {
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <DrawerTrigger asChild={true}><TriggerIcon /></DrawerTrigger>;
      $[9] = t8;
    } else {
      t8 = $[9];
    }
    let t9;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <VisuallyHidden><DrawerTitle /></VisuallyHidden>;
      $[10] = t9;
    } else {
      t9 = $[10];
    }
    let t10;
    if ($[11] !== currentItemLabel || $[12] !== items) {
      let t11;
      if ($[14] !== currentItemLabel) {
        t11 = item => <MobileItem key={item.label} item={item} isCurrent={item.label === currentItemLabel} onClick={handleOpenChange} />;
        $[14] = currentItemLabel;
        $[15] = t11;
      } else {
        t11 = $[15];
      }
      t10 = [...items].reverse().map(t11);
      $[11] = currentItemLabel;
      $[12] = items;
      $[13] = t10;
    } else {
      t10 = $[13];
    }
    let t11;
    if ($[16] !== t10) {
      t11 = <DrawerContent className="data-[vaul-drawer-direction=bottom]:bg-popover [&>div:first-child]:bg-foreground/30 mt-0 mb-0 rounded-t-xl border-none bg-transparent data-[vaul-drawer-direction=bottom]:bottom-0">{t9}<div className="flex flex-col overflow-hidden px-4 py-2 hover:rounded-md">{t10}</div></DrawerContent>;
      $[16] = t10;
      $[17] = t11;
    } else {
      t11 = $[17];
    }
    let t12;
    if ($[18] !== open || $[19] !== t11) {
      t12 = <Drawer open={open} onOpenChange={setOpen}>{t8}{t11}</Drawer>;
      $[18] = open;
      $[19] = t11;
      $[20] = t12;
    } else {
      t12 = $[20];
    }
    return t12;
  }
  let t8;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <DropdownMenuTrigger asChild={true}><TriggerIcon /></DropdownMenuTrigger>;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== itemsToRender) {
    t9 = itemsToRender.map(_temp);
    $[22] = itemsToRender;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t9) {
    t10 = <DropdownMenuContent align="start" className="bg-popover max-w-49 min-w-49.25 flex-1 rounded-xl border-none px-2 py-1 shadow-lg"><div className="flex flex-col py-1">{t9}</div></DropdownMenuContent>;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== open || $[27] !== t10) {
    t11 = <DropdownMenu open={open} onOpenChange={setOpen} modal={false}>{t8}{t10}</DropdownMenu>;
    $[26] = open;
    $[27] = t10;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
}
function _temp(item_0) {
  return <DropdownMenuItem key={item_0.label} asChild={true} className="focus:bg-accent block w-full min-w-0 cursor-pointer p-0 px-3 py-2 text-sm font-normal"><Link href={item_0.href} className="text-foreground w-full truncate px-2 py-2 font-normal">{item_0.label}</Link></DropdownMenuItem>;
}
export { DotsSegment };